module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-plus-3658f039.svg";